export default {
  title: 'Mobilapp',
  fields: {
    name: 'Appnavn',
  },
  buttons: {
    save: 'Gem',
  },
};
